export const registrationDocumentStatusConstantes = Object.freeze({
  TO_SEND: 1,
  SENT: 2,
  DEPOSITED: 3,
  CORRECTION_REQUESTED: 4,
  VERIFIED: 5,
});
